// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__wQq8_","row":"ProcedureTreatmentSummary_row__3FNRq"};